import React from 'react';

import { withRouter } from 'react-router';
import { compose } from 'recompose';

import axios from 'axios';
import {
  debounce,
  map,
  isEmpty,
  isString,
  pickBy,
} from 'lodash';
import { isEmail } from 'validator';
import {
  Icon,
  Grid,
  Responsive,
} from 'semantic-ui-react';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';
import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import { authService } from '../../utils/auth-service';
import InfluencerCardPreview from '../../components/influencer-card-preview';
import { reportError } from '../../utils/error-handling-service';

import AddInfluencerToOrganisation from '../../utils/add-influencer-to-organisation';

import ThemeSelector from '../../themes/theme-selector';


import InfluencerSetupForm from '../../components/influencer-setup-form';

const ENROLLED_BY = {
  self: 'SELF',
};

const toObject = string => ({ value: string });

class NewInfluencerRegistration extends React.Component {
  constructor() {
    super();

    // TODO: Find out if pages are still supposed to just create their own restClient?
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 5000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
    this.state = { influencer: null };
  }

  componentDidMount() {
    this.loadInfluencer();
    // const theme = ThemeSelector.theme();
  }


  onInfluencerChange = influencer => {
    this.setState({ influencer });
  }

  onSubmit = () => {
    const { influencer } = this.state;
    const {
      id,
      name,
      country,
      email,
      facebook,
      twitter,
      youtube,
      website,
      contentTags,
      previousClients,
      willNotWorkWith,
      setupComplete,
      contactNumber,
      addressLine1,
      region,
      postalCode,
      city,
    } = influencer;
    const influencerPatch = {
      name,
      country,
      email,
      facebook,
      twitter,
      youtube,
      website,
      contactNumber,
      addressLine1,
      region,
      postalCode,
      city,
      contentTags: map(contentTags, toObject),
      previousClients: map(previousClients, toObject),
      willNotWorkWith: map(willNotWorkWith, toObject),
      setupComplete: true,
    };

    const safePatch = pickBy(influencerPatch);

    const requestData = { data: { attributes: safePatch } };
    this.restClient.patch(`/influencer/${id}`, requestData)
      .then(() => {
        if (!setupComplete) {
          const { organisationId } = ThemeSelector.theme();
          return AddInfluencerToOrganisation({ ...influencer, brandTags: previousClients }, organisationId);
        }
        return true;
      })
      .then(() => this.props.history.push('/new-influencer/welcome'))
      .catch(e => {
        console.error('Can not patch influencer', e);
        reportError('CANNOT_PATCH_NEW_INFLUENCER', e);
      });
  }

  loadInfluencer = () => {
    const profile = authService.getProfile();
    const organisationId = profile.app_metadata.dyzio.o_id;

    const { jsonAPIClient } = this.props;
    jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] })
      .then(organisation => organisation.toJSONTree())
      .then(org => {
        const { influencer } = org;
        const selfEnrolled = (influencer.enrolledBy === ENROLLED_BY.self);
        return this.setState({
          influencer: {
            ...influencer,
            contentTags: map(influencer.contentTags, 'value'),
            previousClients: map(influencer.previousClients, 'value'),
            willNotWorkWith: map(influencer.willNotWorkWith, 'value'),
          },
          selfEnrolled,
        });
      })
      .catch(e => {
        console.log(e);
        reportError('CANNOT_LOAD_NEW_INFLUENCER', e);
      });
  }
  canSubmit = ({
    name,
    country,
    email,
    agreedToShareWithDyzio,
    agreedToTermsOfUse,
    setupComplete,
    facebook, facebookError, facebookLoading,
    twitter, twitterError, twitterLoading,
    youtube, youtubeError, youtubeLoading,
  }) => !isEmpty(name)
      && !isEmpty(country)
      && isString(email) && isEmail(email)
      && (setupComplete || (agreedToShareWithDyzio && agreedToTermsOfUse))
      && (!facebook || (!facebookError && !facebookLoading))
      && (!twitter || (!twitterError && !twitterLoading))
      && (!youtube || (!youtubeError && !youtubeLoading))

  render = () => {
    const { influencer } = this.state;
    return (
      <Grid divided stackable>
        <Grid.Row>
          <Grid.Column width={10}>
            {
              influencer && (<InfluencerSetupForm
                influencer={influencer}
                onChange={debounce(this.onInfluencerChange, 200)}
              />)
            }
            {
              influencer && (
                <DyzioPrimaryButton
                  fluid
                  label="Submit your application"
                  hasIcon
                  disabled={!this.canSubmit(influencer)}
                  onClick={this.onSubmit}
                  icon={<Icon name="save" />}
                />
              )
            }
          </Grid.Column>
          <Responsive width={6} as={Grid.Column} minWidth={768}>
            {influencer && (<InfluencerCardPreview {...influencer} />)}
          </Responsive>
        </Grid.Row>
      </Grid>
    );
  }
}

export default compose(
  hasUserInfo,
  withRouter,
  hasJSONAPIClient,
)(NewInfluencerRegistration);



/** WEBPACK FOOTER **
 ** ./src/containers/new-influencer-registration/index.js
 **/